import { render, staticRenderFns } from "./fieldCollection.vue?vue&type=template&id=cf6d6964&"
import script from "./fieldCollection.vue?vue&type=script&lang=js&"
export * from "./fieldCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports